import { Component } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { environment } from '../environments/environment';

/**
 * The native Angular bootstrap root (selector `ft-account-app`), hosting the app chrome:
 * the back-to-top button, the routed `<ui-view>`, and the space-switcher / create-flow modals.
 * Also wires production-only GTM (UA-94027034-11) via the shared UIRouter transition hook.
 *
 * Workaround: the back-to-top keeps the `[ft-scroll-to]` shim but drops the v1 show-on-scroll
 * trigger; it is kept hidden at rest via global `.ft-btn-backtotop:not(.is-displayed){display:none}`.
 */
@Component({
    selector: 'ft-account-app',
    templateUrl: './app-root.component.html',
    standalone: false
})
export class AppRootComponent {
    private static gtmScriptAdded = false;

    constructor(router: UIRouter) {
        if (!AppRootComponent.gtmScriptAdded && environment.production) {
            AppRootComponent.gtmScriptAdded = true;

            const gtmScript = document.createElement('script');
            gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=UA-94027034-11';
            gtmScript.async = true;
            document.head.appendChild(gtmScript);

            const startupScript = document.createElement('script');
            startupScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-94027034-11');`;
            document.head.appendChild(startupScript);

            router.transitionService.onSuccess({}, () => {
                (window as any).gtag('config', 'UA-94027034-11', { 'page_path': `${window.location.pathname}` });
            });
        }
    }
}
